import { groupLifeProposalsService } from '@/services/proposals/group-life';
import { useQuery } from '@tanstack/react-query';

const STALE_FIVE_MIN = 5 * 60 * 1000;

export function useGroupLifeProposalDetails(policyId?: string) {
  return useQuery({
    queryKey: ['group-life-proposal', policyId],
    queryFn: async () => {
      if (!policyId) throw new Error('policyId é obrigatório');
      const result = await groupLifeProposalsService.getProposalDetails(policyId);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Falha ao carregar a proposta');
      }
      return result.data;
    },
    enabled: !!policyId,
    staleTime: STALE_FIVE_MIN,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
